const error = {
  namespaced: true,
  state: {
    code: Number,
    message: String,
  },
  getters: {
    getCode: (state) => {
      return state.code
    },
    getMessage: (state) => {
      return state.message
    },
  },
  actions: {
    setCode: ({ commit }, code) => {
      commit('setCode', code)
    },
    setMessage: ({ commit }, message) => {
      commit('setMessage', message)
    },
  },
  mutations: {
    setCode(state, code) {
      state.code = code
    },
    setMessage(state, message) {
      state.message = message
    },
  },
}

export default error
